import script from "./ElementInfoDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementInfoDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ElementInfoDialog.vue?vue&type=style&index=0&id=70d9073f&lang=scss"
import "./ElementInfoDialog.vue?vue&type=style&index=1&id=70d9073f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d9073f"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBtn});
